import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "m-4"
}

import { useAuth0 } from '@auth0/auth0-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeContent',
  setup(__props) {

const { isAuthenticated } = useAuth0();

return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createTextVNode("Welcome to "),
        _hoisted_2,
        _createTextVNode("Manager Client")
      ]),
      content: _withCtx(() => [
        (!_unref(isAuthenticated))
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Please Login"))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})